export default "__VITE_ASSET__f242f7c6__"